import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import {
  Input,
  Button,
  Carousel,
  CarouselItem,
  Form,
  FormItem,
  Checkbox,
  Message,
  MessageBox,
  Upload,
  Dialog
} from 'element-ui'

Vue.use(Input)
Vue.use(Button)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Dialog)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm



// WEBPACK FOOTER //
// ./src/plugins/iview.js